import { render, staticRenderFns } from "./select-product-or-points.vue?vue&type=template&id=5d0d0437&scoped=true"
import script from "./select-product-or-points.vue?vue&type=script&lang=js"
export * from "./select-product-or-points.vue?vue&type=script&lang=js"
import style0 from "./select-product-or-points.vue?vue&type=style&index=0&id=5d0d0437&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0d0437",
  null
  
)

export default component.exports